import React, { lazy } from 'react';
import { withSuspense } from "../../utils/functions";

const ModalSK = lazy(() => import('../../components/ModalSK'));
const ModalSKZip = lazy(() => import('../../components/ModalSKZip'));
const ModalAddResponsiblePerson = lazy(() => import('../../components/ModalAddResponsiblePerson'));
const ModalEditResponsiblePerson = lazy(() => import('../../components/ModalEditResponsiblePerson'));
const ModalShipmentCheckFIFO = lazy(() => import('../../components/ModalShipmentCheckFIFO'));
const ModalShipmentSubmerge = lazy(() => import('../../components/ModalShipmentSubmerge'));
const ModalShipmentRedeemConsignment = lazy(() => import('../../components/ModalShipmentRedeemConsignment'));
const ModalShipmentReturn = lazy(() => import('../../components/ModalShipmentReturn'));
const ModalPostStock = lazy(() => import('../../components/ModalPostStock'));
const ModalPostStockConsignment = lazy(() => import('../../components/ModalPostStockConsignment'));
const ModalProcessingStart = lazy(() => import('../../components/ModalProcessingStart'));
const ModalAwaitingProcessingStart = lazy(() => import('../../components/ModalAwaitingProcessingStart'));
const ModalShipmentPlan = lazy(() => import('../../components/ModalShipmentPlan'));
const ModalShipmentPlanCancel = lazy(() => import('../../components/ModalShipmentPlanCancel'));
const ModalShipmentCancelReason = lazy(() => import('../../components/ModalShipmentCancelReason'));
const ModalDeletingPiece = lazy(() => import('../../components/ModalDeletingPiece'));
const ModalShipmentPlanReady = lazy(() => import('../../components/ModalShipmentPlanReady'));
const ModalShipmentAddReportOverdue = lazy(() => import('../../components/ModalShipmentAddReportOverdue'));
const ModalShipmentSZRebinding = lazy(() => import('../../components/ModalShipmentSZRebinding'));
const ModalTN = lazy(() => import('../../components/ModalTN'));
const ModalTnDriver = lazy(() => import('../../components/ModalTN/ModalDriver'));
const ModalTnDriverAdd = lazy(() => import('../../components/ModalTN/ModalDriverAdd'));
const ModalTnList = lazy(() => import('../../components/ModalTN/ModalTnList'));
const ModalTnPackingType = lazy(() => import('../../components/ModalTN/ModalPackingType'));
const ModalTnPackingTypeAdd = lazy(() => import('../../components/ModalTN/ModalPackingTypeAdd'));
const ModalTnVehicle = lazy(() => import('../../components/ModalTN/ModalVehicle'));
const ModalTnVehicleAdd = lazy(() => import('../../components/ModalTN/ModalVehicleAdd'));
const ModalVideoViewer = lazy(() => import('../../components/ModalVideoViewer'));
const ModalResponsiblePerson = lazy(() => import('../../components/ModalTN/ModalResponsiblePerson'));
const ModalResponsiblePersonAdd = lazy(() => import('../../components/ModalTN/ModalResponsiblePersonAdd'));
const ModalTransportCompany = lazy(() => import('../../components/ModalTN/ModalTransportCompany'));
const ModalTransportCompanyAdd = lazy(() => import('../../components/ModalTN/ModalTransportCompanyAdd'));
const ModalShipmentClientArrivalDate = lazy(() => import('../../components/ModalShipmentClientArrivalDate'));
const ModalSelectFields = lazy(() => import('../../components/Modal/ModalSelectFields'));

const ModalContainer = ({
  modalReducer: {
    loadedModalSK,
    loadedModalSKZip,
    loadedModalShipmentCheckFIFO,
    loadedModalShipmentSubmerge,
    loadedModalShipmentRedeemConsignment,
    loadedModalShipmentReturn,
    loadedModalPostStock,
    loadedModalPostStockConsignment,
    loadedModalProcessingStart,
    loadedModalAwaitingProcessingStart,
    loadedModalShipmentPlan,
    loadedModalShipmentPlanCancel,
    loadedModalShipmentCancelReason,
    loadedModalDeletingPiece,
    loadedModalShipmentPlanReady,
    loadedModalShipmentAddReportOverdue,
    loadedModalSZRebinding,
    loadedModalShipmentClientArrivalDate,
    loadedModalSelectFields
  },
  responsiblePersonReducer: {
    loadedMobileResponsiblePersonsOnSpock,
    loadedMobileEditResponsiblePersonsOnSpock
  },
  tnReducer: {
    loadedModal
  },
  userManualReducer: {
    loadedModalVideoViewer
  },
  isHub,
  isNotUseShippingContainer,
  isOffBalanceSheet,
  isReadyStock,
  isTtnAttachmentRequired,
  isUseBuyer,
  isUseBuyoutWithTtn,
  isUseCheckSeparation,
  isUseCreditLimitCheck,
  isUseDZCheck,
  isUseM15B,
  isUseM4,
  isUseMhOnExpeditor,
  isUsePDZCheck,
  isUseShippingVehicleOnly,
  isUseStorageLevels,
  plantId,
  printQcFromQmet,
  printQcFromStorage,
  shippingType,
  useQcGenerationShipment
}) => (
  <>
    {loadedModalSK && withSuspense(<ModalSK printQcFromQmet={printQcFromQmet}
                                            printQcFromStorage={printQcFromStorage}/>)}
    {loadedModalSKZip && withSuspense(<ModalSKZip printQcFromQmet={printQcFromQmet}
                                                  printQcFromStorage={printQcFromStorage}/>)}
    {loadedModalShipmentCheckFIFO && withSuspense(<ModalShipmentCheckFIFO />)}
    {loadedModalShipmentRedeemConsignment && withSuspense(
      <ModalShipmentRedeemConsignment isReadyStock={isReadyStock}
                                      isHub={isHub}
                                      isTtnAttachmentRequired={isTtnAttachmentRequired}
                                      isUseBuyer={isUseBuyer}
                                      isUseBuyoutWithTtn={isUseBuyoutWithTtn}
                                      isUseCreditLimitCheck={isUseCreditLimitCheck}
                                      isUseDZCheck={isUseDZCheck}
                                      isUseM4={isUseM4}
                                      isUseM15B={isUseM15B}
                                      isUsePDZCheck={isUsePDZCheck}
                                      shippingType={shippingType}
                                      useQcGenerationShipment={useQcGenerationShipment} />)}
    {loadedModalPostStockConsignment && withSuspense(
      <ModalPostStockConsignment isUseM4={isUseM4}
                                 shippingType={shippingType} />)}
    {loadedMobileResponsiblePersonsOnSpock && withSuspense(<ModalAddResponsiblePerson plantId={plantId} />)}
    {loadedMobileEditResponsiblePersonsOnSpock && withSuspense(<ModalEditResponsiblePerson plantId={plantId} />)}
    {loadedModalShipmentSubmerge && withSuspense(<ModalShipmentSubmerge />)}
    {loadedModalShipmentPlanReady && withSuspense(<ModalShipmentPlanReady />)}
    {loadedModalShipmentReturn && withSuspense(<ModalShipmentReturn />)}
    {loadedModalPostStock && withSuspense(<ModalPostStock isUseStorageLevels={isUseStorageLevels}/>)}
    {loadedModalProcessingStart && withSuspense(<ModalProcessingStart />)}
    {loadedModalShipmentPlan && withSuspense(<ModalShipmentPlan plantId={plantId} />)}
    {loadedModalShipmentPlanCancel && withSuspense(<ModalShipmentPlanCancel plantId={plantId} />)}
    {loadedModalShipmentCancelReason && withSuspense(<ModalShipmentCancelReason />)}
    {loadedModalDeletingPiece && withSuspense(<ModalDeletingPiece plantId={plantId} />)}
    {loadedModalAwaitingProcessingStart && withSuspense(<ModalAwaitingProcessingStart />)}
    {loadedModalShipmentAddReportOverdue && withSuspense(<ModalShipmentAddReportOverdue />)}
    {loadedModalSZRebinding && withSuspense(<ModalShipmentSZRebinding />)}
    {loadedModal.TN && withSuspense(<ModalTN plantId={plantId} />)}
    {loadedModal.vehicle && withSuspense(<ModalTnVehicle plantId={plantId} />)}
    {loadedModal.vehicleAdd && withSuspense(<ModalTnVehicleAdd plantId={plantId} />)}
    {loadedModal.driver && withSuspense(<ModalTnDriver plantId={plantId} />)}
    {loadedModal.driverAdd && withSuspense(<ModalTnDriverAdd plantId={plantId} />)}
    {loadedModal.packingType && withSuspense(<ModalTnPackingType plantId={plantId} />)}
    {loadedModal.packingTypeAdd && withSuspense(<ModalTnPackingTypeAdd plantId={plantId} />)}
    {loadedModal.tnList && withSuspense(<ModalTnList plantId={plantId} />)}
    {loadedModal.responsiblePerson && withSuspense(<ModalResponsiblePerson plantId={plantId} />)}
    {loadedModal.responsiblePersonAdd && withSuspense(<ModalResponsiblePersonAdd plantId={plantId} />)}
    {loadedModal.transportCompany && withSuspense(<ModalTransportCompany plantId={plantId} />)}
    {loadedModal.transportCompanyAdd && withSuspense(<ModalTransportCompanyAdd plantId={plantId} />)}
    {loadedModalVideoViewer && withSuspense(<ModalVideoViewer />)}
    {loadedModalShipmentClientArrivalDate && withSuspense(<ModalShipmentClientArrivalDate />)}
    {loadedModalSelectFields && withSuspense(<ModalSelectFields />)}
  </>
);

export default React.memo(ModalContainer);
